import { useLazyQuery } from "@apollo/client";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { ItemNotification } from "components/ItemNotification";
import SearchBox from "components/SearchBox";
import { TableFooter } from "components/Table/Footer";
import { ROW_PER_PAGE_OPTIONS } from "config";
import useText from "constants/text";
import { Slogan } from "domains/Task/components/Slogan/Slogan";
import { EPlatform } from "generated/graphql";
import { useCurrentUser } from "hooks/useCurrentUser";
import React from "react";
import { STATUS_CODE } from "utils/status";
import { GET_NOTIFICATIONS } from "../graphql/queries";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "70%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
    },
    pageTitle: {
      padding: 20,
      paddingLeft: 0,
      fontSize: 24,
      fontWeight: 900,
      color: "#1a224b",
    },
    container: {
      display: "flex",
      flexDirection: "column",
    },
    boody: {
      background: "#fff",
      height: "55vh",
      padding: 20,
      paddingRight: 0,
      borderRadius: 14,
    },
    notifications: {
      height: "45vh",
      padding: 20,
      overflow: "auto",
      whiteSpace: "nowrap",
    },
    search: {
      padding: 20,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    input: {
      "&.MuiInputBase-input": {
        height: "0.2rem",
      },
    },
  })
);

export function Notification() {
  const { text } = useText();
  const styles = useStyles();
  const [notifications, setNotifications] = React.useState([]);
  const { user } = useCurrentUser();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [notificationAccount, setNotificationAccount] = React.useState(0);
  const [filter, setFilter] = React.useState({ page: 1, limit: 5, search: "" });
  const [getNotifications, { data }] = useLazyQuery(GET_NOTIFICATIONS, {
    fetchPolicy: "cache-and-network",
  });

  React.useEffect(() => {
    if (user?.company_user_clientId)
      getNotifications({ variables: { viewerID: user?.company_user_clientId, filter, platform: EPlatform.Client } });
  }, [filter]);

  React.useEffect(() => {
    if (data?.results?.code === STATUS_CODE.OK) {
      setNotificationAccount(data?.results?.countTotal ? data?.results?.countTotal : 0);
      setNotifications(data?.results?.data?.length ? data?.results?.data : []);
    }
  }, [data]);

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(Number(event.target.value));
    setFilter({ ...filter, limit: Number(event.target.value) });
  };

  const handleChangePage = (event: unknown, page: number) => {
    setPage(page);
    setFilter({ ...filter, page: page + 1 });
  };
  return (
    <div className={styles.root}>
      <div className={styles.pageTitle}>{text.all.my_notifications}</div>
      <div className={styles.container}>
        <div>
          <Slogan showButton={false} />
        </div>
        <div className={styles.boody}>
          <div className={styles.search}>
            <SearchBox className={styles.input} />
            <TableFooter
              count={notificationAccount}
              rowsPerPage={rowsPerPage}
              page={page}
              rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
          <div className={styles.notifications}>
            {notifications.length ? (
              notifications.map((notification, index) => (
                <ItemNotification
                  key={`${index}_${notification?._id}`}
                  notification={notification}
                  onClick={() => {}}
                />
              ))
            ) : (
              <div>No Notifications</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
